import React, { useState } from "react";
import { D, JAKARTA } from "../ui";
import { AssetPreview, CircleThumb, PreviewModal, statusOf } from "./AssetPreview";
import { Building2, Eye, Layers } from "lucide-react";

export function AssetCard({ b, idx, onOpen }) {
  const [label, ink, bg] = statusOf(b);
  const nVar = (b.variants || []).length;
  const [showPv, setShowPv] = useState(false);
  return (
    <div data-testid={`asset-${b.bid}`}
      style={{ background: "#fff", borderRadius: 20, overflow: "hidden", boxShadow: "0 6px 18px rgba(20,20,20,0.06)", fontFamily: JAKARTA, transition: "transform 0.15s, box-shadow 0.15s" }}
      onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 14px 30px rgba(20,20,20,0.12)"; }}
      onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 6px 18px rgba(20,20,20,0.06)"; }}>
      <button onClick={onOpen} style={{ width: "100%", textAlign: "left", background: "none", border: 0, padding: 0, cursor: "pointer", fontFamily: JAKARTA }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7, padding: "12px 14px 8px" }}>
          <span style={{ fontSize: 10.5, fontWeight: 800, color: "#b9b6a6", width: 20 }}>{String(idx + 1).padStart(2, "0")}</span>
          <Building2 size={13} color="#8a8776" />
          <span style={{ fontSize: 12.5, fontWeight: 700, color: D.ink, flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{b.name}</span>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: ink, flex: "none" }} />
        </div>
        <AssetPreview def={b} />
      </button>
      <div style={{ padding: "10px 14px 12px" }}>
        <p style={{ margin: 0, fontSize: 11, color: D.sub, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{b.desc || `${b.w}x${b.h} • ${b.floors} lantai`}</p>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 9, gap: 6 }}>
          <span style={{ display: "inline-flex", gap: 4, alignItems: "center", fontSize: 10.5, fontWeight: 700, color: D.sub }}>
            <Layers size={12} /> {nVar} varian
          </span>
          <span style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
            <button data-testid={`asset-preview-${b.bid}`} onClick={() => setShowPv(true)}
              style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "4px 10px", borderRadius: 99, border: "1.5px solid #ece9dc", background: "#fff", color: D.blue, fontSize: 10.5, fontWeight: 800, cursor: "pointer", fontFamily: JAKARTA }}>
              <Eye size={11} /> Preview
            </button>
            <span data-testid={`asset-status-${b.bid}`} style={{ padding: "3px 10px", borderRadius: 99, fontSize: 10.5, fontWeight: 800, background: bg, color: ink }}>{label}</span>
          </span>
        </div>
      </div>
      {showPv && <PreviewModal def={b} label={label} onClose={() => setShowPv(false)} />}
    </div>
  );
}

export function AssetRow({ b, idx, onOpen }) {
  const [label, ink, bg] = statusOf(b);
  return (
    <button data-testid={`asset-${b.bid}`} onClick={onOpen}
      style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", textAlign: "left", background: "#fff", border: 0, borderRadius: 16, padding: "10px 16px", boxShadow: "0 4px 14px rgba(20,20,20,0.05)", fontFamily: JAKARTA, cursor: "pointer" }}>
      <span style={{ fontSize: 10.5, fontWeight: 800, color: "#b9b6a6", width: 20 }}>{String(idx + 1).padStart(2, "0")}</span>
      <CircleThumb def={b} />
      <span style={{ flex: 1, minWidth: 0 }}>
        <b style={{ display: "block", fontSize: 13, color: D.ink }}>{b.name}</b>
        <span style={{ fontSize: 11, color: D.sub }}>{b.category} • {b.w}x{b.h} • {(b.variants || []).length} varian</span>
      </span>
      <span style={{ padding: "3px 10px", borderRadius: 99, fontSize: 10.5, fontWeight: 800, background: bg, color: ink }}>{label}</span>
    </button>
  );
}
